import { Box, Flex } from '@atlaskit/primitives';
import React from 'react';

export interface AskRovoIconProps {
  height?: number;
  width?: number;
  noPadding?: boolean;
}

export const AskRovoIcon: React.FC<AskRovoIconProps> = ({
  height = 12,
  width = 12,
  noPadding = false,
}) => (
  <Box padding={noPadding ? 'space.0' : 'space.050'}>
    <Flex>
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.30067 0.225632C6.85611 -0.0807374 7.53403 -0.0751091 8.08496 0.242517L12.4174 2.74212L13.4448 3.33486C14.0057 3.65826 14.3529 4.25827 14.3529 4.90464V11.0894C14.3529 11.7383 14.0078 12.3357 13.4452 12.6589L9.41621 14.9835C9.42502 14.9587 9.43344 14.9338 9.44144 14.9087C9.51623 14.6769 9.55587 14.4321 9.55587 14.1818V7.99703C9.55587 7.14738 9.10364 6.36386 8.36603 5.94L7.62184 5.51083L5.36265 4.20798V1.81225C5.36265 1.62347 5.39185 1.43906 5.44712 1.26449C5.58299 0.841996 5.87196 0.476236 6.2673 0.247911L6.2685 0.24722C6.27984 0.240681 6.29062 0.233429 6.30067 0.225632Z"
          fill="#BF63F3"
        />
        <path
          d="M4.93673 1.01655L0.90772 3.34108C0.345105 3.66432 0 4.26167 0 4.91061V11.0954C0 11.7418 0.34714 12.3417 0.908088 12.6651L1.86336 13.2163L6.26798 15.7575C6.8189 16.0751 7.49686 16.0807 8.05226 15.7744C8.06232 15.7666 8.07303 15.7594 8.08436 15.7528C8.48013 15.5247 8.76955 15.1588 8.90563 14.7361C8.96102 14.5614 8.99029 14.3768 8.99029 14.1878V11.792L6.6589 10.4475L5.98709 10.0601C5.24961 9.63624 4.79707 8.85256 4.79707 8.003V1.81822C4.79707 1.56828 4.8366 1.32375 4.91119 1.09231C4.91928 1.0669 4.9278 1.04164 4.93673 1.01655Z"
          fill="#BF63F3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.6589 10.4475L1.86336 13.2163L0.908088 12.6651C0.34714 12.3417 0 11.7418 0 11.0954V4.91061C0 4.26167 0.345105 3.66432 0.90772 3.34108L4.93673 1.01655C4.9278 1.04164 4.91928 1.0669 4.91119 1.09231C4.8366 1.32375 4.79707 1.56828 4.79707 1.81822V8.003C4.79707 8.85256 5.24961 9.63624 5.98709 10.0601L6.6589 10.4475Z"
          fill="#1868DB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.62184 5.51083L5.36265 4.20798V1.81225C5.36265 1.62347 5.39185 1.43906 5.44712 1.26449C5.58299 0.841996 5.87196 0.476236 6.2673 0.247911L6.2685 0.24722C6.27984 0.240681 6.29062 0.233429 6.30067 0.225632C6.85611 -0.0807374 7.53403 -0.0751091 8.08496 0.242517L12.4174 2.74212L7.62184 5.51083Z"
          fill="#BF63F3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4448 3.33486L12.4174 2.74212L7.62184 5.51083L8.36603 5.94C9.10364 6.36386 9.55587 7.14738 9.55587 7.99703V14.1818C9.55587 14.4321 9.51623 14.6769 9.44144 14.9087C9.43344 14.9338 9.42502 14.9587 9.41621 14.9835L13.4452 12.6589C14.0078 12.3357 14.3529 11.7383 14.3529 11.0894V4.90464C14.3529 4.25827 14.0057 3.65826 13.4448 3.33486Z"
          fill="#FCA700"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.6589 10.4475L1.86336 13.2163L6.26798 15.7575C6.8189 16.0751 7.49686 16.0807 8.05226 15.7744C8.06232 15.7666 8.07303 15.7594 8.08436 15.7528C8.48013 15.5247 8.76955 15.1588 8.90563 14.7361C8.96102 14.5614 8.99029 14.3768 8.99029 14.1878V11.792L6.6589 10.4475Z"
          fill="#82B536"
        />
      </svg>
    </Flex>
  </Box>
);
